import teamStoreMutations from '@/state/teamStore/teamStoreMutations'
import teamStoreActions from '@/state/teamStore/teamStoreActions'
import getTeamStoreDefaultState from '@/state/teamStore/teamStoreDefaultState'

let state = getTeamStoreDefaultState()

export const teamStore = {
  namespaced: true,
  state,
  getters: {
    teamName: state => (state.team.name ? state.team.name : ''),
    // eslint-disable-next-line no-unused-vars
    showPrices: (state, getters, rootState, rootGetters) => {
      // let isTeamOwner = rootGetters['profile/isTeamOwner']
      // if (isTeamOwner){
      //   return true
      // }

      return state.team.showPrices
    }
  },
  mutations: teamStoreMutations,
  actions: teamStoreActions
}
